import { FC } from 'react'
import * as styles from 'components/features/socialFeed/FeedUserInfo/FeedUserInfo.styl'
import * as cn from 'classnames'
import { FeedUser } from 'interfaces/feed'
import { FeedUserBadge } from 'components/features/socialFeed/FeedUserInfo/FeedUserBadge'

type FeedUserBadgesExtendedProps = {
  user: FeedUser
}

export const FeedUserBadgesExtended: FC<FeedUserBadgesExtendedProps> = (props) => {
  const { user } = props

  if (!user || !user.badges) {
    return null
  }

  const { badges } = user
  const verifiedBadge = badges.find(({ slug }) => slug === 'verified')
  const premiumBadge = badges.find(({ slug }) => slug === 'premium')

  if (!verifiedBadge && !premiumBadge) {
    return null
  }

  const verifiedChild = !!verifiedBadge && (
    <div className={ cn(styles.badge, styles.verified) }>
      <FeedUserBadge badge={ verifiedBadge } mode='default' />
      Verified
    </div>
  )

  const premiumChild = !!premiumBadge && (
    <div className={ styles.badge }>
      <FeedUserBadge badge={ premiumBadge } mode='default' />
      Premium
    </div>
  )

  const dividerChild = !!verifiedBadge && !!premiumBadge && (
    <div className={ styles.divider } />
  )

  return (
    <div className={ styles.badges }>
      { verifiedChild }
      { dividerChild }
      { premiumChild }
    </div>
  )
}
